/** Etichette tipo spesa Prima Nota (allineate al backend / PrimaNotaOspiti). */
export const TIPI_SPESA_LABEL = {
  parrucchiere: "Parrucchiere",
  podologo: "Podologo",
  visita_specialistica: "Visita specialistica",
  acquisto_ausili: "Acquisto ausili",
  altro: "Altro",
};

/** Testo voce fattura in UI: corregge descrizioni salvate come codice tipo. */
export function voceDescrizionePerUI(voce) {
  const d = (voce?.descrizione ?? "").trim();
  if (voce?.tipo === "spesa_prima_nota" && d && TIPI_SPESA_LABEL[d]) {
    return TIPI_SPESA_LABEL[d];
  }
  return d || "—";
}

/** Riepilogo contenuto fattura per elenchi. */
export function fatturaContenutoRiepilogo(voci) {
  if (!voci?.length) {
    return { label: "—", hint: "" };
  }
  const hasR = voci.some((v) => v.tipo === "retta");
  const hasPn = voci.some(
    (v) => v.tipo === "spesa_prima_nota" || v.tipo === "consumo_prima_nota",
  );
  if (hasR && hasPn) return { label: "Retta + extra", hint: "Retta e Prima Nota" };
  if (hasR) return { label: "Retta", hint: "Solo soggiorno" };
  if (hasPn) return { label: "Extra / consumi", hint: "Solo Prima Nota" };
  return { label: "Altro", hint: "Voci manuali o miste" };
}

function normalizeNomeCompare(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Etichetta elenco fatture: Destinatario (Ospite) se diversi.
 * @returns {{ primary: string, secondary: string|null, full: string, ospite: string, destinatario: string }}
 */
export function labelDestinatarioOspite({ destinatarioNome, ospiteNome } = {}) {
  const dest = String(destinatarioNome || "").trim();
  const osp = String(ospiteNome || "").trim();
  if (dest && osp && normalizeNomeCompare(dest) !== normalizeNomeCompare(osp)) {
    return {
      primary: dest,
      secondary: osp,
      full: `${dest} (${osp})`,
      ospite: osp,
      destinatario: dest,
    };
  }
  const sole = dest || osp || "—";
  return {
    primary: sole,
    secondary: null,
    full: sole,
    ospite: osp || sole,
    destinatario: dest || sole,
  };
}
